import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HeaderDataService {
  private idSubject = new BehaviorSubject<bigint | null>(null);
  id$ = this.idSubject.asObservable();

  setId(id: bigint | null): void {
    this.idSubject.next(id);
  }
}
